import dayjs from "dayjs";

/**
 * computeMinutesFromHours
 */

export const computeMinutesFromHours = (x: string | null): number => {
  try {
    if (x === null) return 0;
    const arr = x.split(':');
    const hours = parseInt(arr[0]);
    const minutes = parseInt(arr[1]);
    if (isNaN(hours) || isNaN(minutes)) return 0;
    return dayjs.duration({ hours, minutes }).asMinutes();
  } catch (_: unknown) {
    return 0;
  }
}



/**
 * computeHoursFromMinutes
 */

export const computeHoursFromMinutes = (x: number | string | null): string => {
  try {
    const normalizedX = typeof x === 'number' ? x : (typeof x === 'string' ? Number(x) : null);
    if (normalizedX === null) return '00:00';
    if (normalizedX === 0) return '00:00';
    const duration = dayjs.duration(normalizedX, 'minutes');
    return duration.format("HH:mm");
  } catch (_: unknown) {
    return '';
  }
}